"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty2 = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports["default"] = exports.FEEDBACK_RECEIVE_STORE_PATHS = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-property"));

var _defineProperties = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-properties"));

var _getOwnPropertyDescriptors = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors"));

var _getOwnPropertyDescriptor = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor"));

var _getOwnPropertySymbols = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols"));

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));

var _defineProperty3 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _GenericStore2 = _interopRequireDefault(require("./../../../../KESI2/Stores/GenericStore"));

var _DataStore = _interopRequireWildcard(require("../../../Stores/DataStore2"));

function ownKeys(object, enumerableOnly) { var keys = (0, _keys["default"])(object); if (_getOwnPropertySymbols["default"]) { var symbols = (0, _getOwnPropertySymbols["default"])(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return (0, _getOwnPropertyDescriptor["default"])(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty3["default"])(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors["default"]) { (0, _defineProperties["default"])(target, (0, _getOwnPropertyDescriptors["default"])(source)); } else { ownKeys(Object(source)).forEach(function (key) { (0, _defineProperty2["default"])(target, key, (0, _getOwnPropertyDescriptor["default"])(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var FEEDBACK_RECEIVE_STORE_PATHS = {
  DATA_INITIALIZED: 'dataInitialized',
  DATA_ERROR: 'dataError',
  FEEDBACKS: 'feedBacks'
};
exports.FEEDBACK_RECEIVE_STORE_PATHS = FEEDBACK_RECEIVE_STORE_PATHS;

var FeedbackReceiveStore = /*#__PURE__*/function (_GenericStore) {
  (0, _inherits2["default"])(FeedbackReceiveStore, _GenericStore);

  var _super = _createSuper(FeedbackReceiveStore);

  function FeedbackReceiveStore() {
    (0, _classCallCheck2["default"])(this, FeedbackReceiveStore);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(FeedbackReceiveStore, [{
    key: "receiveChangesCompleted",
    value: function receiveChangesCompleted(message) {
      var _updatedState;

      // ignore other messages on the channel
      if (message.name !== 'update' && message.name !== 'updateLikes') return;
      console.log('updateLikes', message);
      var updatedState = (_updatedState = {}, (0, _defineProperty3["default"])(_updatedState, FEEDBACK_RECEIVE_STORE_PATHS.DATA_INITIALIZED, true), (0, _defineProperty3["default"])(_updatedState, FEEDBACK_RECEIVE_STORE_PATHS.DATA_ERROR, null), _updatedState);
      var data = message.data;
      if (typeof message.data === 'string') data = JSON.parse(message.data);

      if (message.name === 'update') {
        var keys = (0, _keys["default"])(data);

        if (keys.length > 0) {
          updatedState[FEEDBACK_RECEIVE_STORE_PATHS.FEEDBACKS] = _objectSpread({}, this.state[FEEDBACK_RECEIVE_STORE_PATHS.FEEDBACKS]);
          keys.forEach(function (key) {
            updatedState[FEEDBACK_RECEIVE_STORE_PATHS.FEEDBACKS][key] = data[key];
          });
        }

        this.setValues(updatedState);
      } else {
        console.log('updateLikes', data);

        var newLikes = _objectSpread({}, data.likes);

        _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.KESI_ALL_LIKES, newLikes);
      }
    }
  }, {
    key: "receiveChangesFailed",
    value: function receiveChangesFailed(message) {
      var _updatedState2;

      console.error('receiveChangesFailed error', message);
      var updatedState = (_updatedState2 = {}, (0, _defineProperty3["default"])(_updatedState2, FEEDBACK_RECEIVE_STORE_PATHS.DATA_INITIALIZED, true), (0, _defineProperty3["default"])(_updatedState2, FEEDBACK_RECEIVE_STORE_PATHS.DATA_ERROR, message.toString()), _updatedState2);
      this.setValues(updatedState);
    }
  }, {
    key: "initialState",
    value: function initialState() {
      var _ref;

      return _ref = {}, (0, _defineProperty3["default"])(_ref, FEEDBACK_RECEIVE_STORE_PATHS.DATA_INITIALIZED, false), (0, _defineProperty3["default"])(_ref, FEEDBACK_RECEIVE_STORE_PATHS.DATA_ERROR, null), (0, _defineProperty3["default"])(_ref, FEEDBACK_RECEIVE_STORE_PATHS.FEEDBACKS, {}), _ref;
    }
  }]);
  return FeedbackReceiveStore;
}(_GenericStore2["default"]);

var feedBackReceiveStore = new FeedbackReceiveStore();
var _default = feedBackReceiveStore;
exports["default"] = _default;